module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/product-images/product-03-e34cc95c5efae4afc40d26d605f808fc.webp";